import { PagePending } from "@/components/ui/PagePending";
import { PassStatus } from "@/api/sales";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { array, fallback, number, object, optional, pipe, string, toMinValue } from "valibot";

const PASS_STATUSES = ["pending", "redeemed", "expired"] as PassStatus[];

export const Route = createFileRoute("/supplier/$supplierId/passes")({
  pendingComponent: PagePending,
  component: lazyRouteComponent(() => import("./+Passes")),
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
    "pass-statuses": fallback(optional(array(string()), PASS_STATUSES), PASS_STATUSES),
  }),
  head: () => ({
    meta: seo({ title: "Passes" }),
  }),
});
